module.exports = __webpack_public_path__ + "img/Frame369.c49bcf24.png";